import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input, Radio, SearchInput, Select, Textarea } from "../../../../ui/inputs/Input";

import useTable from "../../../../components/useTable";
const headCells = [
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Descripción",
    textAlign: "center",
  },
  {
    id: "tipoPag",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Tipo Pag.",
    textAlign: "center",
  },
  {
    id: "nomArchivo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nom. Archivo",
    textAlign: "center",
  },
];

export default function ReportesVacaciones({ show, setShow, setTabla }) {
  const [tableData, setTableData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    tableData,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Seleccionar Tipo de Pago</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <nav>
          <div className="nav nav-tabs mb-2" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-formatoReporte-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-formatoReporte"
              type="button"
              role="tab"
              aria-controls="nav-formatoReporte"
              aria-selected="true"
            >
              Formato de Reporte
            </button>
            <button
              className="nav-link"
              id="nav-criteriosSeleccion-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-criteriosSeleccion"
              type="button"
              role="tab"
              aria-controls="nav-criteriosSeleccion"
              aria-selected="false"
            >
              Criterios de Selección
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-formatoReporte"
            role="tabpanel"
            aria-labelledby="nav-formatoReporte-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0">
              <TblContainer>
                <TblHead />
                <tbody>
                  {tableData &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={index}></tr>
                    ))}
                </tbody>
              </TblContainer>
            </div>
            <div className="col-12 m-0 mt-2 p-0">
              <Textarea label = 'Descripción:' style = {{ height: 70 }} />
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-criteriosSeleccion"
            role="tabpanel"
            aria-labelledby="nav-criteriosSeleccion-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Integrante:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Ced. Integrante:</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Fec. Retorno:</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Banco</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Cod. Departamento</span>
              <div className="col-3 m-0 p-0">
                <SearchInput label = 'Desde:' />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <SearchInput label = 'Hasta:' />
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Fec. de Vacaciones</span>
              <div className="col-3 m-0 p-0">
                <Input label = 'Desde:' type = 'date'/>
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input label = 'Hasta:' type = 'date'/>
              </div>
            </div>
            <div className="col-12 m-0 mb-2 p-0 d-flex">
              <span className="col-6 m-0 p-0 fw-bold">Período de Vacaciones</span>
              <div className="col-3 m-0 p-0">
                <Input />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input />
              </div>
            </div>
            <div className="col-5 m-0 p-0">
              <Select label = 'Clase Concepto:' ></Select>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
